export const USER_AUTHORIZATION_TOKEN_KEY = 'USER_AUTHORIZATION_TOKEN';
export const USER_SESSION_STATE_KEY = 'USER_SESSION_STATE';
export const USER_SESSION_CACHED = 'USER_SESSION_CACHED';
export const USER_SESSION_REFRESHED = 'USER_SESSION_REFRESHED';
export const LOGIN_VISIT_REDIRECT_PATH = 'LOGIN_VISIT_REDIRECT_PATH';
export const USER_SESSION_ID = 'USER_SESSION_ID';
export const USER_SESSION_COOKIE_EXPIRY_TIME =
  'USER_SESSION_COOKIE_EXPIRY_TIME';
/**
 * Domains for which we want to enable bulk operations via Catalyst V2 APIs
 */
export const CATALYST_V2_ALLOWED_DOMAINS = ['MC', 'INTERVENTIONS', 'WA', 'DT'];
export const BULK_EMAILS_ALLOWED_DOMAINS = ['MC'];
